import styles from "../../components/TimelineOverview/TimelineOverview.module.scss";
import i18n from "../../constants/i18n";
import { Chart } from "react-google-charts";
import React, { useMemo } from "react";

interface MusicStatsViewProps {
    isLoading: boolean;
    data: any[];
    musicStatsDownload: () => Promise<void>;
    locationId: number;
    onBackToOverviewClick: () => void;
    title: string;
}

export function MusicStatsView(props: MusicStatsViewProps) {
    const pieData = useMemo(() => {
        if (
            !props.data ||
            !Array.isArray(props.data) ||
            props.data.length === 0
        )
            return null;
        const header = ["Song", "Play Count"];
        const rows = props.data.map((song: any) => [
            `${song.title ?? "Unknown"} - ${song.artist ?? "Unknown Artist"}`,
            Number(song.playCount ?? 0),
        ]);
        return [header, ...rows];
    }, [props.data]);

    const options = {};
    if (props.isLoading) {
        return <div>{i18n.generic.loadingMusicStats}</div>;
    }

    const downloadStats = async () => {
        await props.musicStatsDownload();
    };

    return (
        <div className="tile is-ancestor">
            <div className="tile is-parent">
                <div className="tile is-child box is-12">
                    <div className="level">
                        <div className="level-left">
                            <div className="level-item">
                                <div className={` ${styles.backButton}`}>
                                    <div onClick={props.onBackToOverviewClick}>
                                        <span className="icon is-small">
                                            <i className="fas fa-chevron-left" />
                                        </span>
                                        <span>
                                            {i18n.generic.backToOverview}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="level-right">
                            <div className="level-item">
                                <div className={` ${styles.backButton}`}>
                                    <div onClick={downloadStats}>
                                        <span className="icon is-small">
                                            <i className="fas fa-download" />
                                        </span>
                                        <span>
                                            {i18n.generic.downloadMusicStats}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h1>{props.title}</h1>
                    {props.data ? (
                        <>
                            <table className="table is-bordered is-striped is-fullwidth">
                                <thead>
                                    <tr>
                                        <th>Pos</th>
                                        <th>Title</th>
                                        <th>Artist</th>
                                        <th>Play Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.data.map((song, index) => (
                                        <tr>
                                            <th>{index + 1}</th>
                                            <td>{song.title ?? "Unknown"}</td>
                                            <td>
                                                {song.artist ??
                                                    "Unknown Artist"}
                                            </td>
                                            <td>{song.playCount ?? 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {pieData ? (
                                <Chart
                                    chartType="PieChart"
                                    data={pieData}
                                    options={options}
                                    width={"100%"}
                                    height={"400px"}
                                />
                            ) : (
                                <div>{i18n.generic.noMusicStatsAvailable}</div>
                            )}
                        </>
                    ) : (
                        <div>{i18n.generic.noMusicStatsAvailable}</div>
                    )}
                </div>
            </div>
        </div>
    );
}
